/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Collapse({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Collapse_svg__a)"><path d="M7.538 5.13a.633.633 0 0 0 .933 0l2-1.966a.7.7 0 0 0 .066-.9.633.633 0 0 0-1-.067l-.866.867V1.331a.667.667 0 0 0-1.333 0v1.733l-.867-.867a.633.633 0 0 0-1 .067.7.7 0 0 0 .067.9zM8.47 10.865a.633.633 0 0 0-.932 0l-2 1.967a.7.7 0 0 0-.067.9.632.632 0 0 0 1 .067l.867-.867v1.733a.667.667 0 0 0 1.333 0v-1.733l.867.867a.632.632 0 0 0 1-.067.7.7 0 0 0-.067-.9zM2.005 7.332h12a.667.667 0 0 0 0-1.333h-12a.667.667 0 0 0 0 1.333M14.005 8.667h-12a.667.667 0 0 0 0 1.333h12a.667.667 0 0 0 0-1.333" /></g><defs><clipPath id="Collapse_svg__a"><path fill="#fff" d="M0 16V0h16v16z" /></clipPath></defs></svg>;
}
;